export default __webpack_public_path__ + "static/media/flip_card_3.903c500f.png";